// Hero Image Carousel for Front Page
// Automatically rotates through featured project images
// Optimized for smooth performance on mobile devices (iOS Safari, Firefox)

const heroImages = [
    {
        src: '/images/projects/ARK00 - Skitse- myndig. projekt - Ny feriehytter i Ribe/IMG_9813.PNG',
        alt: 'Moderne feriehytter i Ribe',
        caption: 'Feriehytter i Ribe'
    },
    {
        src: '/images/projects/ARK02 - Skitseprojekt mm. - Ny landejendom i Gredstedbro/IMG_9774.JPG',
        alt: 'Ny landejendom i Gredstedbro',
        caption: 'Landejendom i Gredstedbro'
    },
    {
        src: '/images/projects/ARK03 - Skitseprojekt - Tilbygning i Gredstedbro/Denne.JPG',
        alt: 'Tilbygning i Gredstedbro',
        caption: 'Tilbygning i Gredstedbro'
    },
    {
        src: '/images/projects/ARK04 - Skitse- myndig. projekt - Ny enfamilieshus i Bramming/IMG_9741 2024-09-27 15_02_27.jpg',
        alt: 'Enfamiliehus i Bramming',
        caption: 'Enfamiliehus i Bramming'
    },
    {
        src: '/images/projects/ARK07 - Myndig. projekt - Ny maskinhus i Vejrup/IMG_9689.JPG',
        alt: 'Maskinhus i Vejrup',
        caption: 'Maskinhus i Vejrup'
    },
    {
        src: '/images/projects/ARK08 - Skitse- myndighedsprojekt - Ribe Camping/B07.png',
        alt: 'Ribe Camping servicebygning',
        caption: 'Ribe Camping'
    }
];

let currentImageIndex = 0;
let carouselInterval = null;
let isTransitioning = false;
let preloadedImages = [];
let prefersReducedMotion = false;

// Check for reduced motion preference
function checkReducedMotion() {
    prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// Preload all images for smoother transitions
function preloadImages() {
    heroImages.forEach((imageData, index) => {
        const img = new Image();
        img.src = imageData.src;
        preloadedImages[index] = img;
    });
}

function initHeroCarousel() {
    const heroImg = document.querySelector('.hero-img');
    const heroImageContainer = document.querySelector('.hero-image-container');
    
    if (!heroImg || !heroImageContainer) {
        console.warn('Hero image element not found');
        return;
    }
    
    // Check reduced motion preference
    checkReducedMotion();
    
    // Listen for changes in motion preference
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => {
        checkReducedMotion();
        if (prefersReducedMotion) {
            stopCarousel();
        } else {
            startCarousel();
        }
    });
    
    // Preload images for smooth transitions
    preloadImages();
    
    // Add CSS class for carousel mode (enables CSS transitions)
    heroImageContainer.classList.add('carousel-active');
    
    // Only start auto-rotation if user doesn't prefer reduced motion
    if (!prefersReducedMotion) {
        startCarousel();
    }
}

function startCarousel() {
    // Don't start if reduced motion is preferred
    if (prefersReducedMotion) return;
    
    if (carouselInterval) {
        clearInterval(carouselInterval);
    }
    carouselInterval = setInterval(() => {
        if (!isTransitioning) {
            currentImageIndex = (currentImageIndex + 1) % heroImages.length;
            updateHeroImage();
        }
    }, 6000);
}

function stopCarousel() {
    if (carouselInterval) {
        clearInterval(carouselInterval);
        carouselInterval = null;
    }
}

function updateHeroImage() {
    const heroImg = document.querySelector('.hero-img');
    const heroImageContainer = document.querySelector('.hero-image-container');
    
    if (!heroImg || !heroImageContainer || isTransitioning) return;
    
    isTransitioning = true;
    const image = heroImages[currentImageIndex];
    
    // Use CSS class-based transitions for better mobile performance
    heroImageContainer.classList.add('fading');
    
    // Wait for fade out, then change image
    setTimeout(() => {
        // Change the image source
        heroImg.src = image.src;
        heroImg.alt = image.alt;
        
        // Wait for image to be ready, then fade back in
        if (heroImg.complete) {
            fadeIn();
        } else {
            heroImg.onload = fadeIn;
            heroImg.onerror = fadeIn; // Still fade in even on error
        }
    }, 600); // Match CSS transition duration
    
    function fadeIn() {
        // Use requestAnimationFrame for smoother animation
        requestAnimationFrame(() => {
            heroImageContainer.classList.remove('fading');
            // Allow next transition after animation completes
            setTimeout(() => {
                isTransitioning = false;
            }, 600);
        });
    }
}

// Stop carousel when page is hidden (performance optimization)
document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
        stopCarousel();
    } else {
        startCarousel();
    }
});

// Pause on user interaction (touch/hover)
function setupInteractionHandlers() {
    const heroImageContainer = document.querySelector('.hero-image-container');
    if (!heroImageContainer) return;
    
    // Pause on hover (desktop)
    heroImageContainer.addEventListener('mouseenter', stopCarousel);
    heroImageContainer.addEventListener('mouseleave', startCarousel);
    
    // Handle touch events (mobile) - don't pause, just ensure smooth operation
    heroImageContainer.addEventListener('touchstart', () => {}, { passive: true });
}

// Initialize carousel when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initHeroCarousel();
        setupInteractionHandlers();
    });
} else {
    initHeroCarousel();
    setupInteractionHandlers();
}
